import { stringify } from "qs";
import Api from "~/service/Api";

class Immersive3dTourExportUrlRepository {
  update(tourId, data, query) {
    let url = `/immersive-3d-tour/export-urls/${tourId}`;

    url += `?${stringify(query)}`;

    return Api.post(url, data);
  }
}

export default Immersive3dTourExportUrlRepository;
